import { render } from "./Partners_1.vue?vue&type=template&id=24e49ebc&ts=true"
import script from "./Partners_1.vue?vue&type=script&lang=ts"
export * from "./Partners_1.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__